<template>
  <div class="app-container" style="padding: 0">
    <list
      row-key="UserId"
      ref="list"
      unit="派工单"
      :page="page"
      show-query
      :query-params="params"
      :get-data-func="api.workDocSummary"
      @reset="$refs.picker.clear()"
      show-checkbox
      @check-change="onCheckChange"
    >
      <template slot="query">
        <el-form-item label="车间" label-width="100px" >
          <v-select style="width: 180px" ref="typeSelect" v-model="params.DpId" clearable/>
        </el-form-item>
        <el-form-item label="加工商">
          <el-select v-model="params.TradeUnitId" clearable >
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Sn" label="序号" width="50px" />
        <el-table-column prop="PropertyName" label="车间/加工商">
          <template slot-scope="{ row }">
            <span>{{ row.ProductionType === 1 ? row.TradeUnitName : row.DpName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProcessStageName" label="加工阶段" />
        <el-table-column prop="ProductNo" label="产品编码" />
        <el-table-column prop="ProductName" label="产品名称" min-width="200px" />
        <el-table-column prop="ProductSpec" label="产品规格" min-width="200px" />
        <el-table-column prop="BatchNumber" label="批号" min-width="120px" />
        <el-table-column prop="UnitName" label="主单位" align="right" />
        <el-table-column prop="Quantity" label="主数量" align="right" />
        <el-table-column prop="UnitName2" label="辅单位" />
        <el-table-column prop="Quantity2" label="辅数量" align="right" />
        <el-table-column prop="DispatchQuantity" label="派工数" align="right" />
        <el-table-column prop="ExistQuantity" label="现存量" align="right" />
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/list'
import list from '@/components/common/list'
import moment from 'moment'
import vSelect from "@/components/business/stock/productionpicking/vSelect";

export default {
  mixins: [listMixin],
  components: {
    list,
    vSelect
  },
  props: {
    tempParams: {
      typeof: Object,
      default: () => {}
    },
    type: {
      type: Boolean,
      default: true
    },
    docType: {
      type: Number,
      default: 1
    },
    tableType: {
      type: Number,
      default: 0
    },
    DictionaryId: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    processList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    tempParams(val) {
      this.params.ProcessStages = val.ProcessStages
      this.params.ProductionType = val.ProductionType
      this.params.InType = val.InType
      this.params.DocDate = val.DocDate
    }
  },
  data() {
    return {
      api: require('@/api/pr/PrDispatchDoc').default,
      commonApi: require('@/api/common/common').default,
      stInDocApi: require('@/api/stock/stInDoc').default,
      //加工类型
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      params: {
        ProcessStages: '', //加工阶段  不可修改
        ProductionType: '', //生产类型 不可修改
        DpId: '', //车间
        TradeUnitId: '', //加工商
        DocDate: ''
      },
      data: {},
      selectList: [],
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      extraList: [],
      TradeUnitName: null,
      tradeUnitList: [],
    }
  },
  created() {
    this.init()
    this.getParams()
  },
  mounted() {
    this.getData()
  },
  methods: {
    init(){
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 3] }).then((res) => {
        this.tradeUnitList = res.Data
      });
    },
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    getParams() {
      this.params.ProcessStages = this.tempParams.ProcessStages
      this.params.ProductionType = this.tempParams.ProductionType
      this.params.DocDate = this.tempParams.DocDate
    },
    del() {},
    checkChange(list) {
      this.list = list
    },
    clear() {
      this.list = []
      this.subList = []
    },
    onCheckChange(list) {
      this.subList = list
    },
    onCheckChange2(data) {
      this.selectList = data
    },
    onClear() {
      this.selectList = []
    }
  }
}
</script>
